import { useState } from "react";
import { useApi } from "src/api";
import { Button } from "src/elements";
import { usePogSummaryModal } from "src/modals/PogSummaryModal/store/hooks";

interface Props {
  storePogId: number;
  isCompact?: boolean;
  isEnabled?: boolean;
}

export const PogSummaryButton = ({ storePogId, isCompact, isEnabled = true }: Props) => {
  const { getPogSummaryApi } = useApi();
  const { openPogSummaryModal } = usePogSummaryModal();

  // Loading with state, because all stores page has many dopamine buttons, need to show spinner only for the one button.
  const [isLoading, setIsLoading] = useState(false);

  const fetchPogSummaryData = async () => {
    setIsLoading(true);

    const response = await getPogSummaryApi(storePogId.toString());

    if (response) {
      openPogSummaryModal(response);
    }

    setIsLoading(false);
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      isLoading={isLoading}
      onClick={fetchPogSummaryData}
      iconLeft={isCompact ? { name: "summary" } : undefined}
      width={isCompact ? "32px" : undefined}
      height={isCompact ? "32px" : undefined}
      isEnabled={isEnabled}
    >
      {!isCompact ? "Pog Analysis" : undefined}
    </Button>
  );
};
